import { IQuery } from "./IQuery";

export default class FilterQuery implements IQuery {
  constructor(attribute: string, operator: Operator, value: string) {
    this.attribute = attribute;
    this.operator = operator;
    this.value = value;
  }

  attribute: string;
  operator: Operator;
  value: string;

  buildQueryString() {
    if (this.operator == Operator.LIKE && !this.value) return null;
    else return `${this.attribute};${this.operator};${this.value}`;
  }
}

export enum Operator {
  LIKE = "l",
  EQUAL = "eq",
  ARRAY_CONTAINS = "ac",
}
